class AccountCoupons {
  constructor() {
    this.activeCouponsCount = 0;
    this.customerOrders = window.shop.yotpo.orders;

    this._initSwellCoupons();
    this._initKlaviyoCoupons()

    this._waitForSwellError();
  }

  // ---------------------
  // Get Yotpo coupons
  // ---------------------
  _initSwellCoupons() {
    let that = this;
    $(document).on("swell:setup", function () {
      try {

        let couponsContainer = document.querySelector('.account__coupons-container');
        let customerDetails = swellAPI.getCustomerDetails();
        if (customerDetails.pointRedemptions.length > 0) {
          let couponsHTML = '';
          for (let i = 0; i < customerDetails.pointRedemptions.length; i++) {
            let point = customerDetails.pointRedemptions[i];

            // check if redemption is coupon

            if (point.redemption_option.discount_type !== 'product' && point.reward_text !== 'Redeemed In Store') {

              let pointName = point.redemption_option.name;
              let pointPercent = pointName.split(' - ');
              let expireCoupon = that._isCouponExpried(point.reward_text, point.created_at, 3);

              if (pointPercent[1] == 'Parrain' || pointPercent[1] == 'Filleul') {
                expireCoupon = that._isCouponExpried(point.reward_text, point.created_at, 6);
              }

              let couponObject = {
                discountTitle: point.reward_text,
                discountOrder: expireCoupon.order,
                discountText1: pointPercent[0],
                discountText2: pointPercent[1],
                discountCreatedAt: point.created_at,
                discountExpireTitle: expireCoupon.title,
                discountExpireDate: expireCoupon.date,
                discountAvailable: expireCoupon.available
              }

              couponsHTML += that._couponsHTMLManager(couponObject);
            }
          }

          let tableContainer = document.querySelector('[data-element="yotpo-table"]');

          if (tableContainer) {
            tableContainer.innerHTML = couponsHTML;
          }

          if (couponsContainer) {
            couponsContainer.classList.remove('yotpo-hidden')
          }

        } else {
          that._checkIfKlaviyoCoupons();
        }

        // set number of coupons in the header title
        that._setHeaderDescription();

        // remove loader
        that._removeLoader();

      } catch (err) {
        Sentry.captureException(err);
      }
    })
  }


  // ---------------------
  // Get Klaviyo coupons
  // ---------------------
  _initKlaviyoCoupons() {
    if (window.shop.yotpo['klaviyoCoupons']) {
      let couponsKlaviyoHTML = '';
      let coupons = window.shop.yotpo['klaviyoCoupons'];

      for (let i = 0; i < coupons.length; i++) {

        let expireCoupon = this._isCouponExpried(coupons[i].discount_name, coupons[i].created_at, 12);

        let couponObject = {
          discountTitle: coupons[i].discount_name,
          discountOrder: i,
          discountText1: (coupons[i].type === 'VIP_20' ? '-20%' : '-10%'),
          discountText2: 'sur votre prochaine commande',
          discountCreatedAt: coupons[i].created_at,
          discountExpireTitle: expireCoupon.title,
          discountExpireDate: expireCoupon.date,
          discountAvailable: expireCoupon.available
        }

        couponsKlaviyoHTML += this._couponsHTMLManager(couponObject);

        let tableContainer = document.querySelector('[data-element="klaviyo-table"]');

        if (tableContainer) {
          tableContainer.innerHTML = couponsKlaviyoHTML;
        }
      }
    }
  }

  _setHeaderDescription() {
    let headerDescription = document.querySelector('[data-element="yotpo-description"]');
    if (headerDescription) {
      if (this.activeCouponsCount > 1) {
        headerDescription.innerHTML = this.activeCouponsCount + ' ' + window.shop.yotpo.headerDescriptionMultiple
      } else {
        headerDescription.innerHTML = this.activeCouponsCount + ' ' + headerDescription.innerHTML
      }
    }

    // set active coupons count in bullet
    if (this.activeCouponsCount > 0) {
      let activeNavLink = document.querySelector('.account-nav__item--loyalty-coupons');
      let couponsCountBullet = document.querySelector('.account-nav__item--loyalty-coupons [data-coupons-count]');
      if (couponsCountBullet) {
        couponsCountBullet.innerHTML = this.activeCouponsCount;
        if (activeNavLink) activeNavLink.classList.add('active');
      }
    }
  }

  _couponsHTMLManager(couponObject) {
    let html = '';
    let couponButton = '';
    let couponText = '';
    let couponUnvailable = '';
    let language = 'fr-FR';
    let discountCreatedAt = 'Date invalide';

    let discountCreatedDate = new Date(couponObject.discountCreatedAt);
    let options = { year: "numeric", month: "numeric", day: "numeric" };

    if (window.location.host === 'en.ohmycream.com') {
      language = 'en-US';
      discountCreatedAt = 'Invalid Date';
    }
    if (discountCreatedDate != 'Invalid Date') {
      discountCreatedAt = new Intl.DateTimeFormat(language, options).format(discountCreatedDate);
    }

    if (couponObject.discountAvailable) {
      couponButton = `
      <a href="#" class="account__coupon-button share-link__button-copy-container button button--with-loader button--with-tooltip" data-action="apply-discount" data-discount="${couponObject.discountTitle}">
        <span class="button__content">${window.shop.yotpo.coupons.use_discount}</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="icon icon-spinner-button-2"><path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"></path></svg>
        <span class="tooltip text-m">${window.shop.yotpo.coupons.discount_applied}</span>
      </a>
      `;
    } else {

      couponButton = `
      <p class="account__coupon-button account__coupon-button--unavailable share-link__button-copy-container button button--primary button--with-loader button--with-tooltip" data-discount="${couponObject.discountTitle}">
        <span class="button__content">${couponObject.discountExpireTitle} ${couponObject.discountExpireDate}</span>
      </p>
      `;
      couponUnvailable = 'unavailable';
    }
    if (couponObject.discountText2) {
      couponText = `
      <span>${couponObject.discountText2}</span>
      `;
    }

    html =
      `
    <tr class="account__coupon-container ${couponUnvailable}" style="order:${couponObject.discountOrder}">
      <td>
        <p class="account__coupon-title">
          <span class="h5 sm:h6">${couponObject.discountText1} </span>
          ${couponText}
        </p>
      </td>
      <td class="account__coupon-line">
        <p class="account__coupon-line-title smallcaps-m sm:smallcaps-s">Créé le</p>
        <p class="account__coupon-line-value text-l">${discountCreatedAt}</p>
      </td>
      <td class="account__coupon-line">
        <p class="account__coupon-line-title smallcaps-m sm:smallcaps-s">${couponObject.discountExpireTitle}</p>
        <p class="account__coupon-line-value text-l">${couponObject.discountExpireDate}</p>
      </td>
      <td class="account__coupon-line">
        <p class="account__coupon-line-title smallcaps-m sm:smallcaps-s">Code</p>
        <p class="account__coupon-line-value text-l">${couponObject.discountTitle}</p>
      </td>
      <td>
        ${couponButton}
      </td>
    </tr>
    `

    return html;
  }

  _isCouponExpried(couponTitle, couponCreationDate, expireMonth) {
    let expireCoupon;
    let hasCouponBeenUsed = false;
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let language = 'fr-FR';
    let expiredDateLang = "Date invalide";
    if (window.location.host === 'en.ohmycream.com') {
      language = 'en-US';
      expiredDateLang = "Invalid Date";
    }
    // check if coupon has been used
    for (const order in this.customerOrders) {
      if (this.customerOrders[couponTitle]) {
        hasCouponBeenUsed = true;
        break;
      }
    }
    if (!hasCouponBeenUsed) {
      let currentDate = new Date(couponCreationDate);
      let expiredDate = new Date(currentDate.setMonth(currentDate.getMonth() + expireMonth));

      if (expiredDate != 'Invalid Date') {
        expiredDateLang = new Intl.DateTimeFormat(language, options).format(expiredDate);
      }

      expireCoupon = {
        title: window.shop.yotpo.coupons.expire,
        date: expiredDateLang,
        order: 1,
        available: (expiredDate.getTime() > new Date().getTime())
      }

      // increment available coupons count
      if (expiredDate.getTime() > new Date().getTime()) {
        this.activeCouponsCount++;
      }

    } else {
      let dateEn = new Date(this.customerOrders[couponTitle].used_at.substr(3, 2) + '/' + this.customerOrders[couponTitle].used_at.substr(0, 2) + '/' + this.customerOrders[couponTitle].used_at.substr(6, 4));
      let usedDate = new Intl.DateTimeFormat(language, options).format(dateEn);

      expireCoupon = {
        title: window.shop.yotpo.coupons.used,
        date: usedDate,
        order: 2,
        available: false
      }

    }

    return expireCoupon;
  }

  _removeLoader() {
    let loader = document.querySelector('.account__coupons-loader');
    if (loader) {
      loader.classList.add('hidden');
    }
  }


  // check if Klaviyo coupons
  _checkIfKlaviyoCoupons() {
    let couponsContainer = document.querySelector('.account__coupons-container');
    if (window.shop.yotpo['klaviyoCoupons']) {
      if (couponsContainer) {
        couponsContainer.classList.remove('yotpo-hidden')
      }
    } else {
      // display coupons empty
      if (document.querySelector('.account__coupons-empty')) {
        document.querySelector('.account__coupons-empty').classList.remove('yotpo-hidden');
      }
    }
  }

  _waitForSwellError() {
    let that = this;

    setTimeout(function () {
      if (typeof swellAPI === 'undefined') {
        if (typeof (Sentry) !== 'undefined') {
          Sentry.captureMessage("Swell not defined", {
            level: "fatal",
            extra: {
              id: window.shop.customerId,
              coupons: JSON.stringify(window.shop.yotpo['klaviyoCoupons']) || null
            }
          });
        }

        // set number of coupons in the header title
        that._setHeaderDescription();
        // check if Klaviyo coupons and remove slider
        that._checkIfKlaviyoCoupons();
        that._removeLoader();
      }
    }, 15000)
  }

}
new AccountCoupons();